import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { IonCard, IonCardContent, IonIcon } from '@ionic/angular/standalone';
import { TranslateModule } from '@ngx-translate/core';

export type EmptyResultVariant = 'default' | 'success' | 'danger' | 'warning';

@Component({
  selector: 'lib-empty-result',
  templateUrl: './empty-result.component.html',
  styleUrls: ['./empty-result.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IonCard, IonCardContent, IonIcon, TranslateModule],
})
export class EmptyResultComponent {
  public readonly text = input.required<string>();
  public readonly icon = input<string | null>('sentiment_dissatisfied_24dp.svg');
  public readonly variant = input<EmptyResultVariant>('default');
}
